import Delegate from "//legramme-qa.com/cdn/shop/t/11/assets/ftdomdelegate.min.js?v=167457923630348017651772640318";

export class BlogSection extends HTMLElement {
    connectedCallback() {
      this.actualCategory   = 'all';
      this.allArticles_el   = document.querySelectorAll(".articles .article");
      this.allblogCategory  = document.querySelectorAll("#allblogCategory button");
  
      this._attachListeners();
      this._loadMoreArticles();
  
    }
  
    _attachListeners() {
        new Delegate(this).on('click', '#loadMoreProducts', this._loadMoreArticles.bind(this));
    }
  
    _loadMoreArticles() {
  
      for (let n = 0; n < 10; n++) {
        if (this.actualCategory === "all") {
          if (document.querySelector(".article[data-show=\"no\"]")) {
            document.querySelector(".article[data-show=\"no\"]").setAttribute("data-show", "");
          }
        } else {
          if (document.querySelector(`.article[data-show="no"][tags="${this.actualCategory}"]`)) {
            document.querySelector(`.article[data-show="no"][tags="${this.actualCategory}"]`).setAttribute("data-show", "");
          }
        }
      }
  
      if (this.actualCategory === "all") {
        if (!document.querySelector(".article[data-show=\"no\"]")) {
          document.querySelector("#loadMoreProducts").classList.add("hide");
        } else {
          document.querySelector("#loadMoreProducts").classList.remove("hide");
        }
      } else {
        if (!document.querySelector(`.article[data-show="no"][tags="${this.actualCategory}"]`)) {
          document.querySelector("#loadMoreProducts").classList.add("hide");
        } else {
          document.querySelector("#loadMoreProducts").classList.remove("hide");
        }
      }
  
    }
  
    _changeDisplayedBlogCategory(category, mobile = false) {
  
      document
        .querySelectorAll(".mobile-blog .bottom button")
        .forEach(x => x.classList.remove("active"));
      if (mobile) {
        mobile.classList.add("active");
      }
  
      this.actualCategory = category;
  
      if (category === "all") {
        this.allArticles_el.forEach(element => {
          element.classList.remove("hide");
        });
      } else {
        this.allArticles_el.forEach(element => {
          element.getAttribute("tags").includes(category)
            ? element.classList.remove("hide")
            : element.classList.add("hide");
        });
      }
  
      this.allblogCategory.forEach(element => {
        element.classList.remove("active");
      });
  
      document.getElementById("blogCategory_" + category).classList.add("active");
      this._loadMoreArticles();
    }
  
  }
  try {
    window.customElements.define('blog-section', BlogSection);
  } catch(e) {}